module.exports = __webpack_public_path__ + "img/reject.37d9ccad.svg";